/* eslint-disable react/destructuring-assignment */
import React, { SVGProps } from 'react';

const Conversion = (props: SVGProps<SVGSVGElement>) => {
  return (
    (<svg
      className={props.className}
      width="26px"
      height="26px"
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      data-palette="Conversion">
      <g id="THE-END" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Conversion-icon-Copy"
          transform="translate(-1306.000000, -44.000000)"
          fillRule="nonzero"
        >
          <g id="Group-2" transform="translate(1306.000000, 44.000000)">
            <g id="Group-23" transform="translate(4.800000, 4.800000)">
              <rect id="Rectangle-12" x="0" y="0" width="11.2" height="11.2" />
              <path
                d="M9.338,7.0574 C9.443,5.9444 8.918,5.4488 8.078,5.2472 C8.63226288,4.98366721 8.94056288,4.38084597 8.8298,3.7772 C8.729,2.7398 7.8344,2.3954 6.7046,2.2946 L6.7046,0.8582 L5.8352,0.8582 L5.8352,2.24 L5.138,2.24 L5.138,0.8582 L4.2644,0.8582 L4.2644,2.2946 L3.7058,2.2946 L2.5004,2.2946 L2.5004,3.227 C2.5004,3.227 3.1472,3.227 3.1346,3.227 C3.37899545,3.19458928 3.60387465,3.36512267 3.6386,3.6092 L3.6386,5.2472 L3.6386,7.5404 C3.6273518,7.71049394 3.48119572,7.83978586 3.311,7.8302 C3.311,7.8302 2.6768,7.8302 2.6768,7.8302 L2.5046,8.876 L4.2686,8.876 L4.2686,10.346 L5.138,10.346 L5.138,8.9054 L5.8352,8.9054 L5.8352,10.346 L6.7088,10.346 L6.7088,8.8928 C8.183,8.8088 9.212,8.4392 9.338,7.0574 Z M5.138,3.2774 C5.6336,3.2774 7.1834,3.122 7.1834,4.151 C7.1834,5.18 5.6336,5.0246 5.138,5.0246 L5.138,3.2774 Z M7.5908,6.8684 C7.5908,7.9562 5.7302,7.8302 5.138,7.8302 L5.138,5.9234 C5.7302,5.9234 7.5908,5.7512 7.5908,6.8852 L7.5908,6.8684 Z"
                id="Shape"
                fill="#FFFFFF"
              />
            </g>
            <g id="Group-51" transform="translate(16.000000, 16.000000)">
              <g
                id="noun_ethereum_1473421"
                transform="translate(2.800000, 0.560000)"
                fill="#FFFFFF"
              >
                <g id="Group">
                  <polygon
                    id="Shape"
                    points="3.07906397 0 3.01180928 0.229640288 3.01180928 6.89326964 3.07906397 6.96071137 6.15814959 5.13233957"
                  />
                  <polygon
                    id="Shape"
                    points="3.07908562 0 0 5.13233957 3.07908562 6.96073554 3.07908562 3.72640921"
                  />
                  <polygon
                    id="Shape"
                    points="3.07906397 7.54638112 3.04116553 7.59279263 3.04116553 9.96652386 3.07906397 10.0777423 6.15997834 5.71892788"
                  />
                  <polygon
                    id="Shape"
                    points="3.07908562 10.0777084 3.07908562 7.54634728 0 5.71889404"
                  />
                  <polygon
                    id="Shape"
                    points="3.07906397 6.96070412 6.15810147 5.13235649 3.07906397 3.72642613"
                  />
                  <polygon
                    id="Shape"
                    points="2.165625e-05 5.13235891 3.07905916 6.96070653 3.07905916 3.72642855"
                  />
                </g>
              </g>
              <rect id="Rectangle-14" x="0" y="0" width="11.2" height="11.2" />
            </g>
            <path
              d="M22.0689655,13.2413793 C26.9443068,13.2413793 30.8965517,17.1936243 30.8965517,22.0689655 C30.8965517,26.9443068 26.9443068,30.8965517 22.0689655,30.8965517 C17.1936243,30.8965517 13.2413793,26.9443068 13.2413793,22.0689655 C13.2468948,17.1959107 17.1959107,13.2468948 22.0689655,13.2413793 Z M22.0689655,12.137931 C16.5842066,12.137931 12.137931,16.5842066 12.137931,22.0689655 C12.137931,27.5537244 16.5842066,32 22.0689655,32 C27.5537244,32 32,27.5537244 32,22.0689655 C32,16.5842066 27.5537244,12.137931 22.0689655,12.137931 Z"
              id="Shape"
              fill="#FFFFFF"
            />
            <path
              d="M28.6896552,8.82758621 C28.6608984,6.93077791 27.6741827,5.17737864 26.0677299,4.16840995 C24.461277,3.15944127 22.4533496,3.03198799 20.7322152,3.82973793 C20.4557742,3.95828849 20.3358853,4.28659901 20.4644359,4.56304 C20.5929864,4.83948099 20.9212969,4.95936987 21.1977379,4.83081931 C21.786118,4.55542828 22.4279445,4.41304507 23.0775834,4.4137931 C25.5401879,4.39072147 27.5569325,6.36504765 27.5862069,8.82758621 L25.3793103,8.82758621 L28.137931,12.137931 L30.8965517,8.82758621 L28.6896552,8.82758621 Z"
              id="Shape"
              fill="#FFFFFF"
            />
            <path
              d="M9.93103448,19.862069 C4.44627559,19.862069 4.90029473e-16,15.4157934 0,9.93103448 C-4.90029473e-16,4.44627559 4.44627559,9.80058946e-16 9.93103448,0 C15.4157934,-9.80058946e-16 19.862069,4.44627559 19.862069,9.93103448 C19.862069,10.2357433 19.6150537,10.4827586 19.3103448,10.4827586 C19.005636,10.4827586 18.7586207,10.2357433 18.7586207,9.93103448 C18.7586207,5.05569324 14.8063757,1.10344828 9.93103448,1.10344828 C5.05569324,1.10344828 1.10344828,5.05569324 1.10344828,9.93103448 C1.10344828,14.8063757 5.05569324,18.7586207 9.93103448,18.7586207 C10.1281465,18.7586207 10.3102856,18.8637787 10.4088416,19.0344828 C10.5073976,19.2051868 10.5073976,19.4155029 10.4088416,19.5862069 C10.3102856,19.7569109 10.1281465,19.862069 9.93103448,19.862069 Z"
              id="Shape"
              fill="#FFFFFF"
            />
          </g>
        </g>
      </g>
    </svg>)
  );
};

export default Conversion;
